import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import VueMeta from 'vue-meta'
import { canObserve } from '@/utils'
import './plugins/vue-register-all-components.js'
import './plugins/flickity.js' // load Flickty plugins
import './plugins/vue-analytics.js'
// import './plugins/google-analytics.js' // load Flickty plugins

const wpDomain = process.env.VUE_APP_WP_BASE_URL
Vue.config.WP = {
  baseUrl: wpDomain,
  API: wpDomain + '/wp-json/wp/v2', // WP REST API
  ACF: wpDomain + '/wp-json/acf/v3', // WP ACF REST API
  BMS: wpDomain + '/wp-json/bms/v1' // BMS endpoints
}

// Image sizes
Vue.config.imgs = {
  baseUrl: process.env.VUE_APP_CLOUDINARY,
  sizes: [320, 480, 640, 800, 1024, 1280, 1440, 1600, 1920, 2400, 2880, 3600, 4096, 5120],
  dpx: window.devicePixelRatio || 1
}

Vue.use(VueLazyload, {
  preLoad: 1.5,
  observer: canObserve()
})

Vue.use(VueMeta)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
